import { Injectable } from "@angular/core";
import {
  BehaviorSubject,
  Observable,
  Subject,
  Subscribable,
  Subscriber,
} from "rxjs";
import { AuthConstants } from "../config/auth-constants";
import { HttpService } from "./http.service";
import { StorageService } from "./storage.service";

import { NavController } from "@ionic/angular";
import { AppComponent } from "../app.component";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { environment } from "src/environments/environment";

import { Plugins } from "@capacitor/core";
import { EncriptadorService } from "./encriptador.service";

const { Storage } = Plugins;

@Injectable({
  providedIn: "root",
})
export class AuthService {
  private _timeRange = new BehaviorSubject<{
    startTime: string;
    endTime: string;
  }>({ startTime: "", endTime: "" });
  timeRange$ = this._timeRange.asObservable();

  private rangos$: Subject<{ startTime: string; endTime: string }>;
  userData$ = new BehaviorSubject<any>("");
  suscribeLicence$ = new Subject<boolean>();
  addProducCar$ = new Subject<number>();
  userPerfil$ = new BehaviorSubject<number>(0);
  constructor(
    private httpSevice: HttpService,
    private storageService: StorageService,
    public navCtrl: NavController,
    private http: HttpClient,
    private encryption: EncriptadorService
  ) {
    this.getUserData();
  }

  updateTimeRange(startTime: string, endTime: string) {
    this._timeRange.next({ startTime, endTime });
  }

  login(postData: any) {
    return this.httpSevice.post("/api-auth/login", postData);
  }

  loginApi(postData: any) {
    return this.httpSevice.post("login-api", postData);
  }

  checkCode(code: string) {
    let formdata = new FormData();
    formdata.append("apiToken", environment.apiToken);
    formdata.append("code", code);
    return this.httpSevice.post("/usuario/apicheckcode?opcion=1", formdata);
  }

  signup(postData: any): Promise<any> {
    return new Promise((resolve, reject) => {
      this.httpSevice
        .post("/site/apisignup-v2", postData)
        .then((response) => {
          resolve(response);
        })
        .catch((err) => {
          console.log("this is error = ", err);
          reject(err);
        });
    });
  }

  logout() {
    this.storageService.get(AuthConstants.AUTH).then((res: any) => {
      const url = environment.host + "/api-auth/refresh-token";
      let TOKEN = res.token;
      let REFRESH_TOKEN: any = res.refresh_token;
      var headers = new HttpHeaders();
      const options = {
        headers: new HttpHeaders(),
        //{'Access-Control-Allow-Headers': 'Origin, Content-Type'}
        body: {
          refresh_token: REFRESH_TOKEN,
        },
      };
      const formData = new FormData();
      formData.append("refresh_token", REFRESH_TOKEN);
      this.http.delete(`${url}`, options).subscribe(
        (del: any) => {},
        (error) => {
          console.log("error:", error);
        }
      );
      //this.storageService.clear();
      this.storageService.removeItem(AuthConstants.AUTH).then((res) => {
        this.userData$.next("");
        this.storageService.clear();
        //this.router.navigate(['']);
        //this.navCtrl.navigateRoot('/login');
      });
      this.storageService.removeItem(AuthConstants.CART).then((res) => {
        this.userData$.next("");
        this.storageService.clear();

        //this.router.navigate(['']);
        this.navCtrl.navigateRoot("/auth/login");
        AppComponent.cartLength = 0;
      });
    });
  }

  refreshToken(): Observable<{}> {
    const url = environment.host + "/api-auth/refresh-token";
    var subject = new Subject<{}>();
    var STORAGE: any = Storage.get({ key: AuthConstants.AUTH });
    let dataStorage = JSON.parse(
      this.encryption.decrypt(
        unescape(atob(STORAGE.__zone_symbol__value.value))
      )
    );
    var headers = new HttpHeaders();
    const options = {};
    const formData = new FormData();
    formData.append("refresh_token", dataStorage.refresh_token);
    return this.http.post(`${url}`, formData, options);
  }

  getUserData() {
    this.storageService.get(AuthConstants.AUTH).then((res) => {
      this.userData$.next(res);
    });
  }

  getAllInstitutes() {
    return this.httpSevice.post("api-all-institutes", {});
  }

  async getInstitutes(page: number, pageSize: number, institutos: string = "") {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };

    const formData = new FormData();

    return this.http.post<any>(
      `${environment.host}/instituciones-admin/api-index?page=${page}&pageSize=${pageSize}&nombre=${institutos}`,
      formData,
      options
    );
  }

  requestPasswordReset(email: string) {
    const formData = new FormData();
    formData.append("correo", email);
    return this.http.post<any>(
      `${environment.host}/usuario/apirestablecercont`,
      formData
    );
  }
  validTokenResetPassword(code: string) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("ref", code);
    return this.http.post<any>(
      `${environment.host}/usuario/apivalidarref`,
      formData,
      options
    );
  }

  changePassword(password: string, code: string) {
    var headers = new HttpHeaders();
    const options = { headers: headers, withCredintials: false };
    const formData = new FormData();
    formData.append("password", password);
    formData.append("ref", code);
    return this.http.post<any>(
      `${environment.host}/usuario/apiguardarcontra`,
      formData,
      options
    );
  }

  loginGoogle(token: string) {
    return this.http.post<any>(`${environment.host}/api-auth/login-google`, {
      token,
    });
  }
}
